import DealTaxesTips from './DealTaxesTips';

export { DealTaxesTips };
